import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import Heading, { HeadingTypes } from '../Heading/Heading';
import Image from '../Image/Image';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';
import { ButtonSize } from '../../interfaces/enums/ButtonSize.enum';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import SbImage from '../SbImage/SbImage';

interface MediumCTABannerBlokProps extends Blok {
  image: StoryblokAsset;
  heading: string;
  body?: string;
  cta?: Blok[];
}

interface MediumCTABannerProps {
  blok: MediumCTABannerBlokProps;
}

const MediumCTABanner: React.FC<MediumCTABannerProps> = ({ blok }) => {
  const { image, heading, body = undefined, cta = [] } = blok;

  return (
    <section className="">
      <div className="relative">
        <Container>
          <Grid>
            <Col
              span={{
                default: 6,
              }}
            >
              <div className="flex flex-col items-center justify-center gap-y-6 lg:items-start py-12 sm:py-10 sm:pr-8">
                <div className="flex flex-col items-center justify-center space-y-4 text-center lg:items-start lg:text-left">
                  {heading && (
                    <Heading text={heading} headingType={HeadingTypes.h3} />
                  )}
                  {body && <p className="text-text/body text-lg">{body}</p>}
                </div>
                {cta.map((cta: Blok) => (
                  <StoryblokComponent
                    blok={{ ...cta, size: ButtonSize.XL }}
                    key={cta._uid}
                  />
                ))}
              </div>
            </Col>
            <Col
              span={{
                default: 6,
              }}
            >
              {image?.filename && (
                <>
                  {/*-- background image --*/}
                  <div className="absolute left-[50%] top-0 w-[50vw] h-full">
                    <SbImage
                      asset={image}
                      options={{
                        objectFit: 'cover',
                        width: 4088,
                        height: 2072,
                        sizes: {
                          base: 1200,
                          sm: 1536,
                          md: 2048,
                          lg: 2560,
                          xl: 3072,
                          xxl: 3840,
                        },
                      }}
                    />
                  </div>
                </>
              )}
            </Col>
          </Grid>
        </Container>
      </div>
    </section>
  );
};

export default memo(withBlokWrapper(MediumCTABanner, Theme.DARK));
